import { render, staticRenderFns } from "./ToggleArea.vue?vue&type=template&id=1d83f90e&scoped=true&"
import script from "./ToggleArea.vue?vue&type=script&lang=js&"
export * from "./ToggleArea.vue?vue&type=script&lang=js&"
import style0 from "./ToggleArea.vue?vue&type=style&index=0&id=1d83f90e&lang=less&rel=stylesheet%2Fless&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d83f90e",
  null
  
)

export default component.exports